import React from 'react';
import AdminLayout from '../../../Components/CommonComponents/Layout/adminLayout';
import EmailCodeContainer from '../../../Containers/AdminContainer/EmailCodes';

const EmailCodeScreen = () => {
  return <EmailCodeContainer />;
};

export default EmailCodeScreen;
